export var GraphType;
(function (GraphType) {
    GraphType["DayAvg"] = "day-avg";
    GraphType["WeekAvg"] = "week-avg";
    GraphType["MonthAvg"] = "month-avg";
})(GraphType || (GraphType = {}));
